import type { UseCase } from '@/core/shared'
import type { UserRepository } from '../domain'

export const addChargersToUser: UseCase<UserRepository, 'addChargersToUser'> = repository => {
  return async (addChargersToUser) => {
    await repository.addChargersToUser(addChargersToUser)
  }
}
